// extracted by css-extract-rspack-plugin
export default {"legal":"legal--tLZcTLJlmgbGGO3E"};